const axios = require("axios");

function sha1(string)
{
    var buffer = new TextEncoder('utf-8').encode(string);

    return crypto.subtle.digest('SHA-1', buffer).then(function (buffer) {
        var hexCodes = [];
        var view = new DataView(buffer);

        for (var i = 0; i < view.byteLength; i += 4) {
            var value = view.getUint32(i)
            var stringValue = value.toString(16)
            var padding = '00000000'
            var paddedValue = (padding + stringValue).slice(-padding.length)
            hexCodes.push(paddedValue);
        }

        return hexCodes.join('');
    });
}

export default function (password) {
    sha1(password).then(function (hash) {
        /**
         * In order to protect the value of the source password being searched
         * for, the end-point will only accept the first 5 characters of the
         * SHA1 hash value.
         *
         * On average, a range search returns 478 hash suffixes, although this
         * number will differ depending on the hash prefix being searched for.
         * The smallest result is 381, the largest 584. There are 1,048,576
         * different hash prefixes between 00000 and FFFFF (16^5) and every
         * single one will return HTTP 200; there is no circumstance in which
         * the API would return HTTP 404.
         *
         * Example Line:
         * -------------
         *   0018A45C4D1DEF81644B54AB7F969B88D65:12345
         *   ^ 35 SHA1 suffix characters         ^ From character 36 is the
         *                                         occurance count
         */

        const request = new XMLHttpRequest();
        request.addEventListener('load', function () {
            const lines = this.responseText.split('\n');
            const suffix = hash.slice(5).toUpperCase();

            for (let line in lines) {
                // If the SHA1 hash matches ours ...
                if (lines[line].substring(0, 35) === suffix) {
                    // ... then emit the occurance count.
                    window.bus.$emit('hibp', window.parseInt(lines[line].slice(36)));
                    return;
                }
            }

            // Else, this password is a snowflake. There is no matching SHA1 in HIBP.
            window.bus.$emit('hibp', 0);
        });
        request.open('GET', `https://api.pwnedpasswords.com/range/${hash.substr(0, 5)}`);
        request.send();

        // axios.get(`https://api.pwnedpasswords.com/range/${hash.substr(0, 5)}`)
        //     .then(response => {
        //         const lines = response.data.split('\n');
        //         const suffix = hash.slice(5).toUpperCase();

        //         for (let line in lines) {
        //             // If the SHA1 hash matches ours ...
        //             if (lines[line].substring(0, 35) === suffix) {
        //                 // ... then emit the occurance count.
        //                 window.bus.$emit('hibp', window.parseInt(lines[line].slice(36)));
        //                 return;
        //             }
        //         }

        //         // Else, this password is a snowflake. There is no matching SHA1 in HIBP.
        //         window.bus.$emit('hibp', 0);
        //     });
    });
}
